export const LEAD_STATUSES = [
  { value: "new", label: "Yeni", color: "hsl(215 16% 45%)", bg: "hsl(210 30% 94%)", fg: "hsl(215 25% 30%)" },
  { value: "called", label: "Aranıldı", color: "hsl(201 96% 40%)", bg: "hsl(199 92% 92%)", fg: "hsl(201 96% 26%)" },
  { value: "proposal", label: "Teklif Verildi", color: "hsl(38 92% 45%)", bg: "hsl(38 92% 90%)", fg: "hsl(24 95% 30%)" },
  { value: "won", label: "Anlaşıldı", color: "hsl(142 60% 38%)", bg: "hsl(142 52% 90%)", fg: "hsl(142 72% 24%)" },
  { value: "not_interested", label: "İlgilenmiyor", color: "hsl(0 72% 50%)", bg: "hsl(0 80% 94%)", fg: "hsl(0 72% 38%)" },
];

export const STATUS_MAP = LEAD_STATUSES.reduce((acc, s) => {
  acc[s.value] = s;
  return acc;
}, {});

// Cold outreach in Germany is restricted without prior consent (UWG §7).
// This is just a record of how contact was authorized, not an enforcement —
// the person sending the message decides, this makes that decision visible.
export const CONSENT_OPTIONS = [
  { value: "none", label: "Onay yok" },
  { value: "verbal", label: "Sözlü onay" },
  { value: "form", label: "Form/İletişim" },
  { value: "reply", label: "Kendisi yazdı" },
];

export const CONSENT_MAP = CONSENT_OPTIONS.reduce((acc, c) => {
  acc[c.value] = c;
  return acc;
}, {});
